import {useApi} from "./useApi";
import {useCallback, useEffect, useState} from "react";
import {useNotify} from "./system/useNotify";
import {Client} from "../api/api";
import {useProfile} from "./useProfile";

export function useAllClients() {
  const [clients, setClients] = useState<Client[]>()
  const {api, isAuth} = useApi(),
    {addNotify, handleApiError} = useNotify(),
    {profile} = useProfile()

  const loadClientsAll = useCallback(() => {
    isAuth && api.getClients({limit: 10000, offset: 0})
      .then(handleApiError)
      .then(setClients)
      .catch(e => addNotify('error', 'Error', e.message))
  }, [addNotify, api, handleApiError, isAuth])

  useEffect(() => {
    if (!clients && profile?.role === "admin") {
      loadClientsAll()
    }
  }, [clients, loadClientsAll, profile])

  return {clients, loadClientsAll}
}
